import type { FunctionComponent } from 'react'
import { memo } from 'react'

import { Article } from '@components/article'
import { Box } from '@components/box'
import { Breadcrumbs } from '@components/breadcrumbs'
import { Section } from '@components/layout/section'
import { SectionOfContent } from '@contentful-components/section-of-content'

export const PageLoadingState: FunctionComponent = memo(() => (
    <>
        <SectionOfContent background={{ label: 'step-white' }} loading />
        <SectionOfContent background={{ label: 'step-cyanora' }} loading />
        <SectionOfContent background={{ label: 'step-white' }} loading />
        <SectionOfContent background={{ label: 'step-midnight' }} loading />
    </>
))

export const ArticlePageLoadingState: FunctionComponent = /*#__PURE__*/ () => (
    <>
        <Section>
            <Box pad={['vertical']}>
                <Breadcrumbs loading current='' links={[]} />
            </Box>
        </Section>
        <Section>
            <Article loading />
        </Section>
    </>
)
